import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: 'tt-error, [ttError]',
  standalone: true,
})
export class FormFieldErrorDirective {
  @HostBinding('class.tt-error') errorClass = true;
}
